import { createSelector } from '@reduxjs/toolkit';
import { scoreboardsAdapter } from '~SpectateStore/slices/scoreboardsSlice';
import { selectVisualizationProvider } from '~SpectateStore/selectors/eventsSelectors';
import { selectSportSlugByEventId } from '~SpectateStore/selectors/sportsSelectors';
import { selectTournamentSlugByEventId } from '~SpectateStore/selectors/tournamentsSelectors';

export const {
    selectById: selectScoreboardById,
} = scoreboardsAdapter.getSelectors(state => state.scoreboards);

export const selectHasScoreboard = (state, eventId) => Boolean(selectScoreboardById(state, eventId));
export const selectHasCoverage = (state, eventId) => selectScoreboardById(state, eventId)?.hasCoverage ?? false;
export const selectScorecentreProvider = (state, key, sportSlug) => state.scoreboards.scorecentreProviders[key]?.[sportSlug] ?? null;
export const selectSportRadarScriptUrl = state => state.scoreboards.scorecentreProviders.BRIN.script ?? null;
export const selectBetGeniusScriptUrl = state => state.scoreboards.scorecentreProviders.BGIN?.script ?? null;
export const selectScorecentreOptions = state => state.scoreboards.scorecentreProviders ?? {};

export const selectIsVisualizationAvailable = createSelector(
    [
        selectVisualizationProvider,
        selectSportSlugByEventId,
        selectTournamentSlugByEventId,
        selectHasCoverage,
        state => state,
    ],
    (provider, sportSlug, tournamentSlug, hasCoverage, state) => {
        // Visualization is available if there's a provider: BG or BR.
        // Also, BG visualization is available if it has a scorecentre provider
        // and if it has coverage or is NFL tournament

        if(provider === 'BR') {
            return true;
        }

        if(provider === 'BG') {
            const hasBgProvider = Boolean(selectScorecentreProvider(state, 'BGIN', sportSlug));

            return hasBgProvider && (hasCoverage || tournamentSlug.toLowerCase() === 'nfl');
        }

        return false;
    },
);

export const selectBetGeniusSportUrl = createSelector(
    [
        selectSportSlugByEventId,
        state => state,
    ],
    (sportSlug, state) => selectScorecentreProvider(state, 'BGIN', sportSlug),
);
